import { Injectable } from '@angular/core'
import { HttpInterceptor, HttpEvent, HttpRequest, HttpHandler } from '@angular/common/http'

import { Observable } from 'rxjs'

@Injectable()
export class HttpCredentialsInterceptor implements HttpInterceptor {
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const reqClone = req.clone({
      withCredentials: true,
    })
    return next.handle(reqClone)
  }
}
